export enum ProcessedInvoiceActionNameEnum {
  SEND = 'SEND',
  RESEND = 'RESEND',
  BACK_TO_REVIEW = 'BACK_TO_REVIEW',
  HISTORY = 'HISTORY',
}
